import type { Doc } from "building-types/doc";
import type { OptionChoices } from "building-types/options/optionChoices";
import type { ViewOverride } from "building-types/selectors/selectorTypes";
import type { Table } from "common/data/table";
import objectFilter from "common/utils/objectFilter";
import { resolveOptionsInFormula, evalFormulas } from "doc/formula/evalFormulas";
import { mergeDocOptionTemplatesIntoOptionSets } from "doc/options/mergeOptionTemplatesIntoOptionSets";

export function filterViewOverridesWithOptionChoices(doc: Doc, optionChoices: OptionChoices): Table<ViewOverride> {
  const definitions = mergeDocOptionTemplatesIntoOptionSets(doc);
  const resolvedOptionChoices = resolveOptionsInFormula(
    { viewOverrides: doc.viewOverrides },
    definitions,
    optionChoices,
  );
  const evaluatedViewOverrides: Table<ViewOverride> = evalFormulas(
    doc.viewOverrides,
    (key) => resolvedOptionChoices[key],
  );
  return objectFilter(evaluatedViewOverrides, (x) => !x.disabled);
}
